// app_routes.js  (PURE DATA — alphabetical by main module)
export const appRoutes = [

  // =========================
  // HOME
  // =========================
  { path: "/", component: "HomePage" },
  { path: "/create-teacher-portal", component: "HomePage", selected: "createTeacherPortal"},
  { path: "/create-parent-portal", component: "HomePage", selected: "createParentPortal"},
  { path: "/create-student-portal", component: "HomePage", selected: "createStudentPortal" },
  //  teacher's link will be playmoneytrain.com/create-student-portal?accountNbr=44821 //
   
  // =========================
  // ABOUT
  // =========================
  { path: "/about", component: "AboutPage" },
  { path: "/about-general", component: "AboutPage", selected: "aboutGeneral" },
  { path: "/about-for-parents", component: "AboutPage", selected: "aboutForParents" },
  { path: "/information-sources", component: "AboutPage", selected: "informationSources" },
  { path: "/game-objectives", component: "AboutPage", selected: "gameObjectives" },

  // =========================
  // ACTIVITIES
  // =========================
  { path: "/activities", component: "Activities" },
  { path: "/select-activity", component: "Activities", selected: "selectActivity" },
  { path: "/choose-a-friend", component: "Activities", selected: "chooseAFriend" },
  { path: "/start-activity", component: "Activities", selected: "startActivity" },
  { path: "/finish-activity", component: "Activities", selected: "finishActivity" },
  
  // =========================
  // ADMINISTRATION
  // =========================
  { path: "/administration", component: "Administration" },
  { path: "/admin-main", component: "Administration", selected: "adminMain" },
  { path: "/events-update", component: "Administration", selected: "eventsUpdate" },
  { path: "/other-updates", component: "Administration", selected: "otherUpdates" },
  { path: "/event-reports", component: "Administration", selected: "eventReports" },
  { path: "/class-reports", component: "Administration", selected: "classReports" },
  { path: "/other-reports", component: "Administration", selected: "otherReports" },

  // =========================
  // CONTACT US
  // =========================
  { path: "/contact-us", component: "ContactUs" },
  { path: "/contact-us-main", component: "ContactUs", selected: "contactUsMain" },
  { path: "/teacher-parent-signup", component: "ContactUs", selected: "teacherParentSignup" },
  { path: "/game-feedback", component: "ContactUs", selected: "gameFeedback" },
  { path: "/player-comments", component: "ContactUs", selected: "playerComments" },

  

  // =========================
  // EXTRA CREDIT
  // =========================
  { path: "/extra-credit", component: "ExtraCredit" },
  { path: "/extra-credit-main", component: "ExtraCredit", selected: "extraCreditMain" },
  { path: "/level1-challenges", component: "ExtraCredit", selected: "level1Challenges" },
  { path: "/level2-challenges", component: "ExtraCredit", selected: "level2Challenges" },
  { path: "/money-calculators", component: "ExtraCredit", selected: "moneyCalculators" },
  { path: "/money-mgmt-test", component: "ExtraCredit", selected: "moneyMgmtTest" },

  // =========================
  // FOR PARENTS
  // =========================
  { path: "/for-parents", component: "ForParents" },
  { path: "/for-parents-main", component: "ForParents", selected: "forParentsMain" },
  { path: "/parents-game-info", component: "ForParents", selected: "parentsGameInfo" },
  { path: "/related-players", component: "ForParents", selected: "relatedPlayers" },
  { path: "/learning-overview", component: "ForParents", selected: "learningOverview" },
  { path: "/player-reports", component: "ForParents", selected: "playerReports" },
  { path: "/discussion-topics", component: "ForParents", selected: "discussionTopics" },

  // =========================
  // GAME VIEW
  // =========================
  { path: "/game", component: "GameView" },
  { path: "/game-board", component: "GameView", selected: "gameBoard" },
  { path: "/game-choices", component: "GameView", selected: "gameChoices" },
  { path: "/change-skills-survey", component: "GameView", selected: "changeSkillsSurvey" },
  { path: "/change-career", component: "GameView", selected: "changeCareer" },
  { path: "/change-home", component: "GameView", selected: "changeHome" },
  { path: "/change-car", component: "GameView", selected: "changeCar" },
  { path: "/unlocked-features", component: "GameView", selected: "unlockedFeatures" },
  { path: "/setup-fun-stuff", component: "GameView", selected: "setupFunStuff" },
  { path: "/setup-savings", component: "GameView", selected: "setupSavings" },
  { path: "/setup-credit-card", component: "GameView", selected: "setupCreditCard" },
  { path: "/setup-time-wizard", component: "GameView", selected: "setupTimeWizard" },
  { path: "/status-display", component: "GameView", selected: "statusDisplay" },
  { path: "/monthly-status", component: "GameView", selected: "monthlyStatus" },
  { path: "/end-game", component: "GameView", selected: "endGame" },
  { path: "/return-gameboard", component: "GameView", selected: "gameBoard" },
  { path: "/money-builder-passthru", component: "GameView", selected: "moneyBuilderPassThru"},

  // =========================
  // GETTING STARTED
  // =========================
  { path: "/skills-interests", component: "GettingStartedDetailed", selected: "skillsInterests" },
  { path: "/choose-career", component: "GettingStartedDetailed", selected: "chooseCareer" },
  { path: "/choose-home", component: "GettingStartedDetailed", selected: "chooseHome" },
  { path: "/choose-car", component: "GettingStartedDetailed", selected: "chooseCar" },
  { path: "/choose-furniture", component: "GettingStartedDetailed", selected: "chooseFurniture" },

  // =========================
  // MONEY BUILDER
  // =========================
  { path: "/moneyBuilder", component: "MoneyBuilder" },
  { path: "/conductor-dashboard", component: "MoneyBuilder", selected: "conductorDashboard" },
  { path: "/bank-accounts", component: "MoneyBuilder", selected: "bankAccounts" },
  { path: "/retirement-account", component: "MoneyBuilder", selected: "retirementAccount" },
  { path: "/investment-select", component: "MoneyBuilder", selected: "investmentSelect" },
  { path: "/transaction-history", component: "MoneyBuilder", selected: "transactionHistory" },

  // =========================
  // SPECIAL ACTIVITY
  // =========================
  { path: "/specialActivity", component: "SpecialActivity" },
  { path: "/special-activity-main", component: "SpecialActivity", selected: "specialActivityMain" },

  // =========================
  // SPECIAL PROCESSES
  // =========================
  { path: "/specialProcesses", component: "SpecialProcesses" },
  { path: "/special-process-main", component: "SpecialProcesses", selected: "specialProcessMain" },
  { path: "/background-picture-test", component: "SpecialProcesses", selected: "backgroundPictureTest" },
  { path: "/test-activities", component: "SpecialProcesses", selected: "testActivities" },
  { path: "/test-dialog", component: "SpecialProcesses", selected: "testDialog" },
  { path: "/display-events", component: "SpecialProcesses", selected: "displayEvents" },
  { path: "/test-spinner", component: "SpecialProcesses", selected: "testSpinner" },

];

export default appRoutes;
